import { styled } from '@mui/material'

export const StyledTabPanel = styled('div')(() => ({}))
